import { EntityApiService } from '@dfl/react-security';
import { IAccountDeletionReason } from 'modules/crm/settings/account-deletion-reason/interfaces';

class AccountDeletionReasonService extends EntityApiService<IAccountDeletionReason> {}

export default new AccountDeletionReasonService('/ms-auth/api/account-deletion-reasons');
